export const blockIconsUiactionsArrowBackiOSNew = (
	<span className='material-symbols-outlined'>arrow_back_ios</span>
);
